export default __webpack_public_path__ + "static/media/buff.8b630a11.jpg";